import { render, staticRenderFns } from "./TablaProductosGrid.vue?vue&type=template&id=ba48d94a&scoped=true"
import script from "./TablaProductosGrid.vue?vue&type=script&lang=js"
export * from "./TablaProductosGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba48d94a",
  null
  
)

export default component.exports